import { render, staticRenderFns } from "./HomeCards.vue?vue&type=template&id=512145f1&scoped=true"
import script from "./HomeCards.vue?vue&type=script&lang=js"
export * from "./HomeCards.vue?vue&type=script&lang=js"
import style0 from "./HomeCards.vue?vue&type=style&index=0&id=512145f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512145f1",
  null
  
)

export default component.exports